export default __webpack_public_path__ + "03094cb4df7319a64ef7ecb079d8235e.png";